import { Box } from "@mui/material";

/**
 * Componente opcional para layout de formulários que não são filhos diretos de FForm.
 * Ex: Campos dentro de abas de formulário.
 */
export default function FormContent({ sx, children, ...props }) {
    return (
        <Box sx={{ display: "flex", alignContent: "flex-start", flex: 1, flexWrap: "wrap", gap: 2, ...sx }}>
            {children}
        </Box>
    );
}
